import { useEffect, useRef } from 'react';
import { useRecoilStateLoadable } from 'recoil';
import { useMakePHPRequest } from '../../../common/useMakePHPRequest';
import { IUserAtom, user } from '../../../recoil/atoms/user';
import { useSnackbarWithStyles } from '../notifications/SnackbarProviderWithStyles';
import { showUpdateCard } from '../stripe/showUpdateCard';

export default function UpdateCardModal(props) {
  const [userAtomLoadable] = useRecoilStateLoadable(user);
  const userAtomContents = userAtomLoadable.contents as IUserAtom;
  const { enqueueSnackbarWithStyles } = useSnackbarWithStyles();
  const phpRequest = useMakePHPRequest({
    userAtom: userAtomContents,
  });
  const updateCardRef = useRef<any>([]);
  useEffect(() => {
    if (userAtomContents?.userid && updateCardRef?.current) {
      updateCardRef?.current?.click();
    }
  }, [userAtomContents, updateCardRef]);
  const handleClose = () => {
    props.onClose();
  };
  return (
    <div
      ref={updateCardRef}
      onClick={showUpdateCard(
        enqueueSnackbarWithStyles,
        phpRequest,
        String(userAtomContents.userid),
        handleClose
      )}
    ></div>
  );
}
